import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue";
import ImageEditor from '@/components/ImageEditor.vue';
import EmitterEvents from '@/events';
import { setupVueI18n } from '@/plugin/vue-i18n';
import { UIContentWrap } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import mitt from 'mitt';
import { createPinia } from 'pinia';
import { getCurrentInstance, onMounted, onUnmounted, provide, ref } from 'vue';
import { EditorType } from '../types';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Editor',
    props: {
        emitter: Object,
        locale: String,
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const pinia = createPinia();
        const localEmitter = mitt();
        const app = (_b = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.appContext) === null || _b === void 0 ? void 0 : _b.app;
        app === null || app === void 0 ? void 0 : app.use(pinia);
        app === null || app === void 0 ? void 0 : app.provide('emitter', localEmitter);
        // inject current route
        provide('parentEmitter', props.emitter);
        setupVueI18n(props.locale);
        const openImageEditor = ref(false);
        const mediaUrl = ref('');
        const locationId = ref('');
        const imageName = ref('');
        function openEditor(eventData) {
            mediaUrl.value = eventData.url;
            locationId.value = eventData.locationId;
            imageName.value = eventData.imageName;
            switch (eventData.type) {
                case EditorType.IMAGE:
                    openImageEditor.value = true;
                    break;
            }
        }
        function closeModal() {
            openImageEditor.value = false;
            mediaUrl.value = '';
        }
        function completeEditing(url) {
            var _a;
            (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.emit(EmitterEvents.IMAGE_EDITOR_COMPLETED, {
                newUrl: url,
                oldUrl: mediaUrl.value,
            });
            closeModal();
        }
        onMounted(() => {
            var _a;
            (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.on(EmitterEvents.IMAGE_EDITOR_OPEN, openEditor);
        });
        onUnmounted(() => {
            var _a;
            (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.off(EmitterEvents.IMAGE_EDITOR_OPEN);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), { fullScreen: true }, {
                default: _withCtx(() => [
                    (mediaUrl.value && openImageEditor.value)
                        ? (_openBlock(), _createBlock(ImageEditor, {
                            key: 0,
                            "image-url": mediaUrl.value,
                            "location-id": locationId.value,
                            "image-name": imageName.value,
                            onClose: completeEditing,
                            onDone: completeEditing
                        }, null, 8 /* PROPS */, ["image-url", "location-id", "image-name"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
